/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import classnames from "classnames";
import CountUp from "react-countup";
import { useSelector, useDispatch } from "react-redux";
import {
  getCandidateResultWithFilterPage,
  getQuizeWithFilter,
  getQuestionWithFilter,
  getAllCandiateWithFilter,
} from "../../slices/thunks";

const CountUpComponent = ({ end }) => {
  return <CountUp start={0} end={end} duration={3} />;
};

const Widget = ({ widget }) => {
  return (
    <Col xl={3} md={6}>
      <Card>
        <CardBody style={{ height: "100px", overflow: "hidden" }}>
          <div className="d-flex align-items-center counter-widget">
            <div className="flex-grow-1">
              <p className="text-uppercase fw-semibold fs-14 text-muted mb-1">
                {widget.label || "Data"}
              </p>
              <h2 className="mb-0 mr-2">
                <CountUpComponent end={widget.counter || 0} />
              </h2>
            </div>
            <div className="avatar-sm flex-shrink-0">
              <span className="avatar-title bg-light text-primary rounded-circle fs-3">
                <i className={"align-middle " + (widget.badgeIcon || "")}></i>
              </span>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

const TileBoxs = () => {
  const [activeTab, setActiveTab] = useState("statistics");
  const dispatch = useDispatch();

  const { quizzes = {} } = useSelector((state) => state.QuizeData || {});
  const { candidateResults = {} } = useSelector((state) => state.candidateResult || {});
  const { questions = {} } = useSelector((state) => state.quizeQuestion || {});

  useEffect(() => {
    dispatch(getQuizeWithFilter());
    dispatch(getAllCandiateWithFilter());
    dispatch(getQuestionWithFilter());
  }, [dispatch]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const widgetData = useMemo(
    () => [
      {
        id: 1,
        label: "Total Quizzes",
        badgeIcon: "las la-clipboard-list",
        counter: Array.isArray(quizzes.data) ? quizzes.data.length : 0,
      },
      {
        id: 2,
        label: "Total Questions",
        badgeIcon: "bx bx-question-mark",
        counter: Array.isArray(questions.data) ? questions.data.length : 0,
      },
      {
        id: 3,
        label: "Total Candidates",
        badgeIcon: "bx bx-user",
        counter: Array.isArray(candidateResults?.data?.data)
          ? candidateResults.data.data.length
          : 0,
      },
    ],
    [quizzes, questions, candidateResults]
  );

  return (
    <React.Fragment>
      <Nav tabs className="nav nav-tabs nav-border-top nav-border-top-primary mb-4 mt-5">
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === "statistics" })}
            onClick={() => toggleTab("statistics")}
          >
            Statistics
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="statistics">
          <Row>
            {widgetData.map((widget) => (
              <Widget key={widget.id} widget={widget} />
            ))}
          </Row>
        </TabPane>
      </TabContent>
    </React.Fragment>
  );
};

export default TileBoxs;
